<template>
    <div class="container">
        <ContentOrLoading>
            <div class="row justify-content-center" v-if="!loading">
                <div class="col-12 col-xl-10">
                    <ul class="grid">
                        <li v-for="precio in precios" :key="precio.id">
                            <div class="thumb">
                                <img :src="precio.url_image" :alt="precio.descripcion" />
                            </div>
                            <div class="content">
                                <div>
                                    <div class="title">
                                        {{  precio.descripcion }}
                                    </div>

                                    <div class="datetime">
                                        {{ precio.resumen }}
                                    </div>
                                </div>

                                <div class="p-3" style="background-color: white;" v-if="precio.stock > 0 && precio.descuentos.length > 0">
                                    <p class="oswald text-uppercase">{{ $t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos}) }}</p>
                                    <div class="form-group">
                                        <multiselect
                                            :disabled="false"
                                            v-model="precio.units"
                                            :placeholder="$t('nuevo_abono.numero_abonos', {abonos: teatro.texto_abonos})"
                                            :show-labels="false"
                                            :options="options(precio)"
                                            :allow-empty="true"
                                        />
                                    </div>
                                </div>
                                <div class="p-3 text-center" style="background-color: white;" v-else>
                                    <h4>{{ $t('nuevo_abono.agotado') }}</h4>
                                </div>                              
                            </div>
                        </li>
                    </ul>
                </div>
                <b-col cols="12" xl="10" class="mt-3" v-if="seleccionado">
                    <button class="button effect-button large-button" @click="bloquearAbonos" :disabled="disabled">
                        Continuar
                    </button>
                </b-col>
            </div>
        </ContentOrLoading>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                precios: [],
                loading: true,
                abonos_max: 8,
                steps: [
                    { label: "Seleccionar abonos", slot: "pasoAbonos" },
                    { label: "Completa tus datos", slot: "pasoDatos" },
                ],
                disabled: false
            }
        },
        created() {
            this.getPrecios();
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            seleccionado() {
                return this.precios.filter(precio => precio.units > 0).length > 0;
            }
        },
        methods: {
            getPrecios() {
                this.$store.dispatch(this.config.getVuexAlias('front.temporada.precios'), { lista_abonado_id: this.lista.id }).then(res => {
                    this.precios = res.data.data;
                }).finally(() => this.loading = false);
            },
            tiempoTerminado() {
                console.log('Tiempo terminado');
            },
            options(precio) {
                var tope = this.abonos_max;

                if(precio.stock < tope) {
                    tope = precio.stock;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            },
            bloquearAbonos() {
                this.disabled = true;
                let precios_formated = [];

                this.precios.forEach(precio => {
                    if(precio.units > 0) {
                        precios_formated.push({
                            id: precio.id,
                            cantidad: precio.units
                        });
                    }
                });

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.abonos'), { 'precios_abonos': precios_formated }).then(res => {
                    this.$emit('abonosSeleccionados', {
                        'session_id': res.data.session_id,
                        'sesiones': res.data.sesiones,
                        'precios_disponibles': this.precios
                    });
                }).finally(() => this.disabled = false);
            }
        }
    }
</script>